<template>
  <div class="flex items-center px-2 bg-gray-200 rounded text-gray-500">
    <fa-icon
      class="search-icon"
      :icon="['fas', 'search']"
    />
    <z-input
      v-model="searchPhrase"
      class="flex-grow"
      :placeholder="$t('Search', 'Search')"
    />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Input from './Input'

library.add(faSearch)
export default {
  components: {
    'fa-icon': FontAwesomeIcon,
    'z-input': Input
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: { type: String, required: true }
  },
  computed: {
    searchPhrase: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
